import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

// TODO: Reemplazar los placeholders [INSERTAR_...] con los datos reales de Coralan Multiservice SRL
// antes del deploy a producción.
const PoliticaPrivacidad = () => {
    return (
        <LegalPageLayout
            seoTitle="Política de Privacidad y Protección de Datos"
            path="/politica-privacidad"
            description="Política de protección de datos personales de Coralan Multiservice SRL conforme a la Ley 172-13 de la República Dominicana."
            breadcrumbLabel="Política de Privacidad"
            title="Política de Protección de Datos Personales"
            subtitle="Coralan Multiservice SRL — Conforme a la Ley Núm. 172-13 de la República Dominicana."
            lastUpdated="Enero 2026"
        >
            <div className="legal-page__content">
                <p className="legal-page__intro">
                    En Coralan Multiservice SRL, en nuestro rol como Proveedor de Servicios
                    de Facturación Electrónica autorizado por la DGII, protegemos los datos
                    personales de nuestros usuarios conforme a la Ley Núm. 172-13 sobre
                    Protección de Datos de Carácter Personal y demás normativas aplicables.
                </p>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">1.</span>
                        Responsable del Tratamiento
                    </h2>
                    <p>
                        <strong>Coralan Multiservice SRL</strong>, con RNC{' '}
                        <strong>1-32-03635-2</strong>, con domicilio en{' '}
                        <strong>C/San Juan Bautista de la Salle #17, Mirador Norte</strong>, Santo Domingo,
                        República Dominicana.
                    </p>
                    <p>
                        Correo de contacto: <strong>info@coralanmultiservice.com</strong>
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">2.</span>
                        Datos Personales que Tratamos
                    </h2>
                    <p>
                        En el ejercicio de nuestras actividades como Proveedor de Servicios
                        de Facturación Electrónica, Coralan Multiservice SRL puede tratar las
                        siguientes categorías de datos:
                    </p>
                    <ul>
                        <li>
                            <strong>Datos de identificación:</strong> nombre completo,
                            número de cédula o pasaporte, RNC.
                        </li>
                        <li>
                            <strong>Datos de contacto:</strong> dirección, correo electrónico,
                            número de teléfono.
                        </li>
                        <li>
                            <strong>Datos de carácter económico y fiscal:</strong> información
                            contenida en los Comprobantes Fiscales Electrónicos (e-CF),
                            datos de transacciones comerciales.
                        </li>
                        <li>
                            <strong>Datos de acceso:</strong> credenciales de usuario,
                            registros de acceso y operaciones en la plataforma.
                        </li>
                        <li>
                            <strong>Datos del certificado digital:</strong> información
                            asociada al certificado digital tributario.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">3.</span>
                        Finalidades del Tratamiento
                    </h2>
                    <p>Los datos personales son tratados para:</p>
                    <ul>
                        <li>Prestación del servicio de Facturación Electrónica contratado.</li>
                        <li>
                            Generación, firma, transmisión y almacenamiento de e-CF conforme
                            a la normativa de la DGII.
                        </li>
                        <li>Cumplimiento de obligaciones legales y tributarias.</li>
                        <li>Gestión de la relación comercial con los contribuyentes.</li>
                        <li>
                            Atención de solicitudes, consultas e incidencias de soporte técnico.
                        </li>
                        <li>Seguridad y control de acceso a la plataforma.</li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">4.</span>
                        Base Legal del Tratamiento
                    </h2>
                    <ul>
                        <li>Ejecución del contrato de servicios suscrito con el contribuyente.</li>
                        <li>
                            Cumplimiento de obligaciones legales (Código Tributario, Ley 126-02,
                            normativas DGII).
                        </li>
                        <li>Consentimiento del titular, cuando aplique.</li>
                        <li>
                            Interés legítimo de la empresa para garantizar la seguridad del servicio.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">5.</span>
                        Derechos de los Titulares
                    </h2>
                    <p>
                        Conforme a la Ley Núm. 172-13, usted tiene los siguientes derechos
                        sobre sus datos personales:
                    </p>
                    <ul>
                        <li>
                            <strong>Acceso:</strong> solicitar información sobre sus datos
                            personales que poseemos.
                        </li>
                        <li>
                            <strong>Rectificación:</strong> solicitar la corrección de datos
                            inexactos o incompletos.
                        </li>
                        <li>
                            <strong>Cancelación:</strong> solicitar la supresión de sus datos
                            cuando ya no sean necesarios.
                        </li>
                        <li>
                            <strong>Oposición:</strong> oponerse al tratamiento en determinadas
                            circunstancias.
                        </li>
                        <li>
                            <strong>Portabilidad:</strong> recibir sus datos en formato
                            estructurado.
                        </li>
                    </ul>
                    <p>Para ejercer estos derechos puede contactarnos por los siguientes medios:</p>
                    <ul>
                        <li>Correo: <strong>info@coralanmultiservice.com</strong></li>
                        <li>Web: <strong>coralanmultiservice.com/politica-privacidad</strong></li>
                        <li>Dirección: <strong>C/San Juan Bautista de la Salle #17, Mirador Norte</strong></li>
                    </ul>
                    <p>
                        <strong>Plazo de respuesta:</strong> 15 días hábiles.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">6.</span>
                        Conservación de los Datos
                    </h2>
                    <ul>
                        <li>
                            <strong>Datos fiscales en e-CF:</strong> mínimo 10 años (Código Tributario).
                        </li>
                        <li>
                            <strong>Datos de acceso y logs:</strong> mínimo 5 años.
                        </li>
                        <li>
                            <strong>Datos de relación comercial:</strong> vigencia del contrato + 5 años.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">7.</span>
                        Transferencia de Datos a Terceros
                    </h2>
                    <p>
                        Coralan Multiservice SRL <strong>no vende datos personales</strong>.
                        Solo los transfiere a:
                    </p>
                    <ul>
                        <li>
                            <strong>La DGII:</strong> en cumplimiento de obligaciones legales.
                        </li>
                        <li>
                            <strong>Proveedores tecnológicos:</strong> bajo acuerdos de
                            confidencialidad.
                        </li>
                        <li>
                            <strong>Autoridades competentes:</strong> cuando sea requerido por ley.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">8.</span>
                        Medidas de Seguridad
                    </h2>
                    <ul>
                        <li>Cifrado en tránsito (TLS 1.2+) y en reposo.</li>
                        <li>Control de acceso con autenticación multifactor.</li>
                        <li>Auditorías y monitoreo continuo.</li>
                        <li>Gestión formal de incidentes de seguridad.</li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">9.</span>
                        Contacto y Reclamaciones
                    </h2>
                    <ul>
                        <li>Correo: <strong>info@coralanmultiservice.com</strong></li>
                        <li>Teléfono: <strong>809-605-0699</strong></li>
                        <li>
                            Dirección: <strong>C/San Juan Bautista de la Salle #17, Mirador Norte</strong>, Santo Domingo,
                            República Dominicana.
                        </li>
                    </ul>
                    <p>
                        También puede presentar reclamación ante el INDOTEL u organismo
                        competente en materia de protección de datos.
                    </p>
                </div>

                <div className="legal-page__cta">
                    <div className="legal-page__cta-text">
                        <p className="legal-page__cta-title">¿Tienes preguntas sobre tus datos?</p>
                        <p className="legal-page__cta-subtitle">
                            Nuestro equipo de soporte está disponible para asistirte.
                        </p>
                    </div>
                    <Link to="/soporte" className="legal-page__cta-btn">
                        Ir a Soporte <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </LegalPageLayout>
    );
};

export default PoliticaPrivacidad;
